import React from 'react'
import { twMerge } from 'tailwind-merge'
import { Severity } from '../types'

const severityClasses: Record<Severity, string> = {
  info: 'bg-blue-100 text-blue-800',
  warning: 'bg-amber-100 text-amber-800',
  high: 'bg-red-100 text-red-800',
}

interface SeverityBadgeProps {
  severity: Severity
}

export const SeverityBadge = ({ severity }: SeverityBadgeProps) => {
  return (
    <span
      className={twMerge(
        'inline-block shrink-0 rounded-sm px-1.5 py-0.5 font-semibold text-[11px] uppercase leading-[14px]',
        severityClasses[severity],
      )}
    >
      {severity}
    </span>
  )
}
